import { ICMMSColumn } from '@shared/ui-components/au-table-layout/utils/interfaces';
import {
	ACTION_TYPES,
	COLUMN_TYPES,
} from '@shared/ui-components/au-table-layout/utils/enums';
import { iconEnum } from '@app/configs/model/IconEnum';
import { TableType } from '../types';

export const attachedEntityTableConfig: ICMMSColumn[] = [
	{
		head: 'name',
		key: 'name',
		type: COLUMN_TYPES.BODY_HEADING,
		isSortable: false,
	},
	{
		head: 'status',
		key: 'status',
		type: COLUMN_TYPES.STATUS,
		isSortable: false,
	},
	{
		head: 'priority',
		key: 'priority',
		type: COLUMN_TYPES.PRIORITY,
		isSortable: false,
	},
	{
		head: 'emty_head',
		key: '',
		type: COLUMN_TYPES.ACTION,
		isSortable: false,
		customData: {
			actions: [ACTION_TYPES.UNLINK, ACTION_TYPES.OPEN_IN_DT],
		},
	},
];

export const sidebarHeaders = {
	[TableType.REQUESTS]: {
		title: { prefix: 'attach', text: 'requests' },
		icon: iconEnum.request,
	},
	[TableType.INCIDENTS]: {
		title: { prefix: 'attach', text: 'incidents' },
		icon: iconEnum.incident,
	},
	[TableType.WORK_ORDER]: {
		title: { prefix: 'attach', text: 'work_orders' },
		icon: iconEnum.cmms,
	},
	[TableType.ASSETS]: {
		title: { prefix: 'attach', text: 'assets' },
		icon: iconEnum.asset,
	},
	[TableType.FILES]: {
		title: { prefix: 'attach', text: 'files' },
		icon: iconEnum.files,
	},
};
